/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps } from '@wordpress/block-editor';

import { useEffect } from '@wordpress/element';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */

import { useState, Fragment } from '@wordpress/element';
import { InspectorControls, BlockControls, AlignmentControl, PanelColorSettings } from '@wordpress/block-editor';
import { RangeControl, TextControl, PanelBody } from '@wordpress/components';
import ServerSideRender from '@wordpress/server-side-render';

export default function Edit( props ) {
	const { setAttributes, attributes } = props;
	const { blockId, seperator, textAlign, textColor, linkColor, separatorColor, textSize  } = attributes;

	const generateUniqueId = ( length = 10 ) => {
        const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		let randomString = '';
		for (let i = 0; i < length; i++) {
			const randomIndex = Math.floor(Math.random() * charset.length);
			randomString += charset[randomIndex];
		}
		return randomString;
    };

	// Set a unique block ID if not already set
    useEffect(() => {
        if (!blockId) {
            setAttributes({ blockId: `templazee-breadcrumb-${generateUniqueId()}` });
        }
    }, [blockId, setAttributes]);

	const linkColorSettings = [
		{
			value: linkColor,
			onChange: colorValue => setAttributes({ linkColor: colorValue }),
			label: __( "Link Color", 'templazee' )
		}
	];

	const textColorSettings = [
		{
			value: textColor,
			onChange: colorValue => setAttributes({ textColor: colorValue }),
			label: __( "Text Color", 'templazee' )
		}
	];

	const separatorColorSettings = [
		{
			value: separatorColor,
			onChange: colorValue => setAttributes({ separatorColor: colorValue }),
			label: __( "Text Color", 'templazee' )
		}
	];


	return (
		<div { ...useBlockProps() }>
			<Fragment>
				<BlockControls>
					<AlignmentControl
						value={textAlign}
						onChange={ ( nextAlign ) => {
							setAttributes( { textAlign: nextAlign } );
						} }
					/>
				</BlockControls>
				<InspectorControls>
					<PanelBody title={ __( 'Breadcrumb Options', 'templazee' ) } >
						<RangeControl
							label={__('Font Size', 'templazee')}
							onChange={ (value) => setAttributes( { textSize: value } ) }
							shiftStep={ 1 }
							min={ 2 }
							max={ 100 }
							value={ textSize }
						/>
						<TextControl
							label="Separator"
							value={seperator}
							onChange={(value) =>
								setAttributes({
								seperator: value,
								})
							}
						/>
					</PanelBody>
					<PanelColorSettings
						title={__('Link Color', 'templazee')}
						colorSettings={linkColorSettings}
						initialOpen={false}
					/>
					<PanelColorSettings
						title={__('Text Color', 'templazee')}
						colorSettings={textColorSettings}
						initialOpen={false}
					/>
					<PanelColorSettings
						title={__('Separator Color', 'templazee')}
						colorSettings={separatorColorSettings}
						initialOpen={false}
					/>
				</InspectorControls>
			</Fragment>
			<ServerSideRender
				block="templazee/breadcrumb"
				attributes={props.attributes}
			/>
		</div>
	);
}
